import React, {useState} from 'react';
import {
  Avatar, Dialog, DialogContent,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LoginElement from "./LoginElement";

export interface ILoginModalProps {
  type: 'login' | 'register' | 'password_reset',
  open: boolean,
  onClose: any,
}


const LoginModal = (props: ILoginModalProps) => {
  return (
    <Dialog
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className="modal"
      open={props.open}
      onClose={props.onClose}
      closeAfterTransition
    >

      <DialogContent >
        <Avatar
          sx={{
            mx: "auto",
            bgcolor: "secondary.main",
            textAlign: "center",
            marginTop: 2,
            marginBottom: 2,
          }}
        >
          <LockOutlinedIcon/>
        </Avatar>
        <LoginElement
          type={props.type}
          onLogin={() => {window.location.reload();}}
        ></LoginElement>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
